const ADD_BREADCRUMBS = 'ADD_BREADCRUMBS';
const REMOVE_BREADCRUMB = 'REMOVE_BREADCRUMB';
export const RESET_BREADCRUMBS = 'RESET_BREADCRUMBS';

export default function reducer(state = [], action) {
  switch (action.type) {
    case ADD_BREADCRUMBS:
      return [...action.payload];
    case REMOVE_BREADCRUMB:
      return state.filter(({ field }) => field !== action.payload);
    case RESET_BREADCRUMBS:
      return [];
    default:
      return state;
  }
}

export function addBreadcrumbs(breadcrumbs) {
  return {
    type: ADD_BREADCRUMBS,
    payload: breadcrumbs,
  };
}

export function removeBreadcrumb(breadcrumb) {
  return {
    type: REMOVE_BREADCRUMB,
    payload: breadcrumb,
  };
}
